import { Drawer, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Toolbar } from '@mui/material';
import HomeIcon from '@mui/icons-material/HomeOutlined';
import OrderIcon from '@mui/icons-material/ContentPaste';
import HistoryIcon from '@mui/icons-material/History';
import ReportIcon from '@mui/icons-material/DescriptionOutlined';

import THEME from '@/app/modules/ECommerce/pages/miniPOS/utils/theme';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useAppAliasIntlFormatter } from '@/app/hooks/formatFeatureName';
import useMiniPOSPermission from '@/app/modules/ECommerce/pages/miniPOS/hooks/useMiniPOSPermission';
import PERMISSION from '@/app/modules/ECommerce/pages/miniPOS/utils/permission.constant';

const MENUS = {
  home: {
    path: 'home',
    icon: HomeIcon
  },
  order: {
    path: 'order',
    icon: OrderIcon
  },
  history: {
    path: 'history',
    icon: HistoryIcon
  },
  report: {
    path: 'reports',
    icon: ReportIcon
  }
};

const MENU_PERMISSION = {
  report: [PERMISSION.REPORT_SALES]
};

const styledIcon = (IconComponent, color = THEME.primary) => <IconComponent sx={{ color, width: 35, height: 35 }} />;

const currPage = key => window.location.pathname.includes(`/${key}`);

const MiniPOSDrawer = ({ width = 100 }) => {
  const formatMessage = useAppAliasIntlFormatter();
  const history = useHistory();
  const { shop } = useSelector(state => state.auth);
  const { canAny } = useMiniPOSPermission();

  return (
    <Drawer
      sx={{
        width: width,
        flexShrink: 0,
        [`& .MuiDrawer-paper`]: { width: width, boxSizing: 'border-box' }
      }}
      variant="permanent"
      anchor="left"
    >
      <Toolbar />
      <List>
        {Object.keys(MENUS)
          .filter(key => {
            const permissions = MENU_PERMISSION[key];

            if (!permissions) return true;

            return canAny(permissions);
          })
          .map(key => {
            const menu = MENUS[key];
            
            return (
              <ListItem key={key} disablePadding>
                <ListItemButton
                  key={key}
                  onClick={() => history.push(`/shop/${shop?.seqId}/mini-pos/${menu.path}`)}
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    py: 1,
                    '&::before': {
                      content: '""',
                      position: 'absolute',
                      left: 0,
                      // top: '20%',
                      height: '100%',
                      width: 4,
                      borderRadius: '0 4px 4px 0',
                      backgroundColor: currPage(key) ? THEME.primary : 'transparent',
                      transition: 'background-color 0.2s ease'
                    }
                  }}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mb: 0.5,
                      display: 'flex',
                      justifyContent: 'center'
                    }}
                  >
                    {styledIcon(menu.icon)}
                  </ListItemIcon>
                  <ListItemText
                    primary={formatMessage({ id: `mini.pos.drawer.menu.${key}` })}
                    sx={{
                      textAlign: 'center',
                      '& .MuiTypography-root': {
                        fontSize: '1.2em',
                        fontWeight: currPage(key) ? 'bold' : 'normal'
                      },
                      m: 0
                    }}
                  />
                </ListItemButton>
              </ListItem>
            );
          })}
      </List>
    </Drawer>
  );
};

export default MiniPOSDrawer;
